import { LockedRoutesStatusResponse } from "../hooks/useToggleAllStatus";
import { AppDispatch } from "../store";
import {
  setAllRoutesAsLockedForPlanning,
  toggleTaskLockedForPlanning,
  undoLockAllRoutes,
} from "../store/ganttChart";
import { setNotification } from "../store/toastNotifications";
import api, { API_PATHS } from "./api";

export class LockAllRoutesApi {
  /**
   * Get the current status of "lock all routes" switch.
   */
  static async getSessionStatus(): Promise<LockedRoutesStatusResponse> {
    const response = await api.get(`${API_PATHS.lockedRoutesStatus}`);
    return response.data;
  }

  static async lockAllRoutes(dispatch: AppDispatch) {
    try {
      await api.get(`${API_PATHS.lockAllRoutes}`);
      dispatch(setAllRoutesAsLockedForPlanning());
      return true;
    } catch (error: any) {
      const data = error.response.data;
      dispatch(
        setNotification({
          message: data.message,
          type: "lock_all_failed",
          variant: "error",
        }),
      );
      return false;
    }
  }

  static async lockTask(
    dispatch: AppDispatch,
    idWorkTask: number,
    lockedForPlanning: boolean,
  ) {
    try {
      await api.post(API_PATHS.lockTask, { idWorkTask, lockedForPlanning });
      dispatch(toggleTaskLockedForPlanning(idWorkTask));
    } catch (error: any) {
      dispatch(
        setNotification({
          message: error.response?.data?.message ?? "Kunne ikke låse besøget. Prøv igen eller kontakt support.",
          variant: "error",
        }),
      );
    }
  }

  static async unlockAllRoutes(dispatch: AppDispatch) {
    try {
      await api.get(`${API_PATHS.unlockAllRoutes}`);
      dispatch(undoLockAllRoutes());
      return true;
    } catch (error: any) {
      const data = error.response.data;
      dispatch(
        setNotification({
          message: data.message,
          type: "unlock_all_failed",
          variant: "error",
        }),
      );
      return false;
    }
  }
}
